export default function splitStringIntoLines(string) {
  let lines = [];
  if (string === "") {
    return lines;
  } else {
    lines = string.split(/\r?\n/);
    if (lines.length == 1) {
      lines = string.split("\\n");
    }
    return lines;
  }
}
